import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const sectionContainerStyles = {
  display: 'flex',
  flexDirection: { md: 'row', xs: 'column' },
  pt: 2,
  px: { sm: 5.5, xs: 2 },
};

const mapSkeletonStyles = {
  height: { sm: '509px', xs: '231px' },
  maxWidth: 850,
  width: '100%',
};

const OverviewSkeleton = () => (
  <Box sx={sectionContainerStyles}>
    <Stack
      mr={{ lg: '12%', md: 4, xs: 0 }}
      pb={{ md: 0, xs: 2 }}
      pt={2}
      px={2}
      spacing={2}
      sx={{ minWidth: { md: '373px', xs: '100%' }, width: { md: '373px', xs: '100%' } }}
    >
      <Stack spacing={1}>
        <Skeleton height="16px" variant="rectangular" width="59px" />
        <Skeleton height="14px" variant="rectangular" width="129px" />
        <Skeleton height="14px" variant="rectangular" width="129px" />
      </Stack>
      <Stack spacing={1}>
        <Skeleton height="16px" variant="rectangular" width="138px" />
        <Skeleton height="14px" variant="rectangular" width="241px" />
        <Skeleton height="14px" variant="rectangular" width="241px" />
        <Skeleton height="14px" variant="rectangular" width="241px" />
      </Stack>
      <Skeleton height="16px" variant="rectangular" width="373px" />
      <Stack spacing={1}>
        <Skeleton height="16px" variant="rectangular" width="127px" />
        <Skeleton height="14px" variant="rectangular" width="106px" />
      </Stack>
      <Stack spacing={1}>
        <Skeleton height="16px" variant="rectangular" width="127px" />
        <Skeleton height="14px" variant="rectangular" width="106px" />
      </Stack>
      <Stack spacing={1}>
        <Skeleton height="16px" variant="rectangular" width="127px" />
        <Skeleton height="14px" variant="rectangular" width="106px" />
      </Stack>
    </Stack>
    <Skeleton sx={mapSkeletonStyles} variant="rectangular" />
  </Box>
);

export default OverviewSkeleton;
